import React from 'react';
import dynamic from 'next/dynamic';
import 'react-quill/dist/quill.snow.css';
import type ReactQuill from 'react-quill';

const QuillWrapper = dynamic(
  async () => {
    const { default: RQ } = await import('react-quill');

    const Quill = RQ.Quill;

    const Embed = Quill.import('blots/block/embed');
    class Divider extends Embed {
      // if you want to add inline style, override create method
      static create(value: any) {
        const node = super.create(value);
        return node;
      }
      // set blotName & tagName
      static blotName = 'divider';
      static tagName = 'hr';
    }

    Quill.register({ 'formats/hr': Divider });

    // eslint-disable-next-line react/display-name
    return ({ ...props }) => {
      props.modules = {
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'image'],
          ['clean'],
        ],
      };

      props.formats = [
        'header',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'code-block',
        'list',
        'bullet',
        'link',
        'image',
        'hr',
        'divider',
      ];

      return <RQ {...props} />;
    };
  },
  {
    ssr: false,
  },
) as typeof ReactQuill;

export default QuillWrapper;
